const template = document.querySelector('body');
const megaMenuHoverSwitchDelay = 120;

/********* Cibles tactiles au comportement natif non reproductible *********/
/* theme.js installe sur document un pont touch -> click (isTouch) qui, sur un tap
   immobile, appelle preventDefault() puis redispatche un MouseEvent synthetique.
   Visible sur WebKit seulement : annuler touchend y supprime le click de
   compatibilite, pas sur Blink ni Gecko. Trois familles de cibles y perdent leur
   comportement, qu'un click synthetique ne sait pas refaire :
   - les champs (input, textarea, select, contenteditable) : absents de la liste
     blanche du pont, leur focus natif est annule sans rien en remplacement, donc
     plus de clavier ni de selecteur au tap ;
   - les liens a target : un click non fiable ne peut pas ouvrir d'onglet, iOS le
     bloque comme un popup. Concerne les liens de link-target.dev (menus du footer,
     multicolumn, card-push) ;
   - shopify-account : aucun de ses ancetres n'est dans la liste blanche, donc le
     pont annule le tap sans emettre de click en remplacement, et le bouton compte
     du header reste mort.
   Un appui long passait, lui : le doigt depasse le seuil de 10px et sort du pont
   avant le preventDefault. On stoppe donc le touchend en phase de capture sur ces
   cibles ; le pont continue d'agir partout ailleurs.
   A retirer quand la garde amont couvrira ces cas : FoxTheme annonce un correctif
   en 2.3.1. Avant de supprimer ce bloc, verifier dans leur theme.js que le return
   est place avant le preventDefault ET que les trois familles ci-dessus sont
   couvertes : leur essai du 03/09/2026 oubliait a[target]. */
document.addEventListener(
    'touchend',
    (event) => {
        if (event.target.closest?.('input, textarea, select, [contenteditable], a[target], shopify-account')) {
            event.stopPropagation();
        }
    },
    true
);

/********* Sticky ATC bar masquee tant que le formulaire principal n'est pas depasse *********/
const stickyAtcBar = document.querySelector('sticky-atc-bar');
const stickyAtcMainForm =
    stickyAtcBar && document.querySelector(`.main-product-form[data-product-id="${stickyAtcBar.dataset.productId}"]`);
if (stickyAtcMainForm) {
    /* Racine prolongee vers le bas : le formulaire n'en sort que par le haut, une fois passe sous le header */
    new IntersectionObserver(
        (entries) => {
            entries.forEach((entry) => {
                document.body.classList.toggle('rdvdeco-before-main-form', entry.isIntersecting);
            });
        },
        { rootMargin: '-80px 0px 100000px 0px' }
    ).observe(stickyAtcMainForm);
}

/********* Sticky ATC bar masquee sur le footer *********/
const stickyAtcFooter = document.querySelector('footer.footer');
if (stickyAtcFooter && stickyAtcBar) {
    new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
            document.body.classList.toggle('rdvdeco-footer-in-view', entry.isIntersecting);
        });
    }).observe(stickyAtcFooter);
}

/********* Navigation *********/
const menusLvl2 = document.querySelectorAll('.mega-menu__submenu-lvl2');
menusLvl2.forEach((menuLvl2) => {
    // Init
    const menuLvl1 = menuLvl2.closest('details');
    const menuLvl2Item = menuLvl2.querySelector('li:first-child');
    let hoverSwitchTimer = null;

    const clearHoverSwitchTimer = () => {
        if (hoverSwitchTimer) {
            clearTimeout(hoverSwitchTimer);
            hoverSwitchTimer = null;
        }
    };

    loadMenu(menuLvl1, menuLvl2Item, '[data-ref]:first-child', ':first-child');
    menuLvl1.addEventListener('mouseleave', (e) => {
        clearHoverSwitchTimer();
        loadMenu(menuLvl1, menuLvl2Item, '[data-ref]:first-child', ':first-child');
    });

    // Hover Lvl2
    if (window.matchMedia('(min-width: 1024px)').matches) {
        const menuLvl2Items = menuLvl1.querySelectorAll('.mega-menu__submenu-lvl2 li');
        menuLvl2Items.forEach((menuLvl2Item) => {
            menuLvl2Item.addEventListener('mouseenter', () => {
                if (!menuLvl2Item.classList.contains('active')) {
                    clearHoverSwitchTimer();
                    hoverSwitchTimer = setTimeout(() => {
                        if (!menuLvl2Item.matches(':hover')) return;
                        const target = menuLvl2Item.getAttribute('data-ref');
                        loadMenu(menuLvl1, menuLvl2Item, '[data-ref="'+target+'"]', '#'+target);
                        hoverSwitchTimer = null;
                    }, megaMenuHoverSwitchDelay);
                }
            });

            menuLvl2Item.addEventListener('mouseleave', clearHoverSwitchTimer);
        });
    }
});
function loadMenu(menuLvl1, menuLvl2, menuLvl3Selector, pushSelector) {
    // Lvl2
    const menuLvl2Active = menuLvl1.querySelector('.mega-menu__submenu-lvl2 li.active');
    if (menuLvl2Active) {
        menuLvl2Active.classList.remove('active');
    }
    menuLvl2.classList.add('active');

    // Lvl3
    const menuLvl3Active = menuLvl1.querySelector('.mega-menu__submenu-lvl3 .active');
    if (menuLvl3Active) {
        menuLvl3Active.classList.remove('active');
    }
    const menuLvl3 = menuLvl1.querySelector('.mega-menu__submenu-lvl3 '+menuLvl3Selector);
    if (menuLvl3) {
        menuLvl3.classList.add('active');
    }

    // Push
    const pushActive = menuLvl1.querySelector('.mega-menu__promotions .active');
    if (pushActive) {
        pushActive.classList.remove('active');
    }
    const push = menuLvl1.querySelector('.mega-menu__promotions .push-wrapper'+pushSelector);
    if (push) {
        push.classList.add('active');
    }
}

/********* Show/Hide *********/
const showHideElements = document.querySelectorAll('.show-hide');
showHideElements.forEach((showHideElement) => {
    const showHideContent = showHideElement.querySelector('.show-hide-content');
    const showHideBtn = showHideElement.querySelector('.show-hide-btn');

    if (showHideContent && showHideBtn) {
        showHideBtn.addEventListener('click', () => {
            showHideElement.classList.toggle('active');

            if (showHideElement.classList.contains('active')) {
                showHideContent.style.maxHeight = showHideContent.scrollHeight + 'px';
            } else {
                showHideContent.style.maxHeight = '';
            }
        });
    }
});

/********* Product card *********/
function sliderCardProduct (productSliders) {
    productSliders.forEach((slider) => {
        // Destroy existing Swiper instance if it exists
        if (slider.swiper) {
            slider.swiper.destroy();
        }

        const sliderOptions = {
            modules: [window.FoxTheme.Swiper.Navigation, window.FoxTheme.Swiper.Pagination],
            slidesPerView: 1,
            spaceBetween: 20,
            pagination: {
                el: slider.querySelector('.swiper-pagination'),
                type: 'progressbar',
            },
            navigation: {
                nextEl: slider.querySelector('.swiper-btn-next'),
                prevEl: slider.querySelector('.swiper-btn-prev'),
            },
            loop: true,
        };

        const sliderInstance = new FoxTheme.Swiper.Swiper(slider, sliderOptions);
        sliderInstance.init();
    });
}
const productSliders = document.querySelectorAll('card-product-image-slider');
sliderCardProduct (productSliders);

setTimeout(()=> {
    const productSliders = document.querySelectorAll('product-slider card-product-image-slider');
    sliderCardProduct (productSliders);
}
,1000);

/********* Product *********/
if (template.classList.contains('product-template')) {
    function changeBadgeLocation() {
        const badgesContainer = document.querySelector('.product__block.product__block--badges');
        const badge = document.querySelector('.product-card__badge');
        const mediaWrapper = document.querySelector('.product__media-wrapper');
        const infoWrapper = document.querySelector('.product__info-wrapper');

        if (!badge || !badgesContainer || !mediaWrapper || !infoWrapper) return;

        if (window.matchMedia('(max-width: 767.98px)').matches) {
            mediaWrapper.appendChild(badge);
        } else {
            badgesContainer.appendChild(badge);
        }
    }

    changeBadgeLocation();
    window.addEventListener("resize", changeBadgeLocation);

    const loadMoreBtn = document.querySelector('.product__media-wrapper .btn[data-load-more]');
    if (loadMoreBtn) {
        const galleryWrapper = document.querySelector('.product__media-wrapper');
        loadMoreBtn.addEventListener('click', () => {
            galleryWrapper.classList.add('active');
        });
    }

    const galleryNav = document.querySelector('.product-gallery-nav');
    if (galleryNav) {
        const wrap = galleryNav.closest('.product__media-gallery-viewer-wrap');
        const swiperPrev = wrap && wrap.querySelector('.swiper-button-prev');
        const swiperNext = wrap && wrap.querySelector('.swiper-button-next');
        galleryNav.querySelector('.product-gallery-nav__prev').addEventListener('click', () => swiperPrev && swiperPrev.click());
        galleryNav.querySelector('.product-gallery-nav__next').addEventListener('click', () => swiperNext && swiperNext.click());
    }

    const popupTriggerProxies = document.querySelectorAll('[data-popup-trigger-source="previous"]');
    popupTriggerProxies.forEach((popupProxy) => {
        const triggerBlock = popupProxy.previousElementSibling;
        const popupButton = popupProxy.querySelector('[data-popup-trigger-button]');
        if (!triggerBlock || !popupButton) return;

        const openPopup = () => popupButton.click();
        triggerBlock.classList.add('cursor-pointer');
        if (!triggerBlock.hasAttribute('tabindex')) triggerBlock.setAttribute('tabindex', '0');
        if (!triggerBlock.hasAttribute('role')) triggerBlock.setAttribute('role', 'button');
        triggerBlock.setAttribute('aria-haspopup', 'dialog');

        const popupId = popupButton.getAttribute('aria-controls');
        if (popupId) triggerBlock.setAttribute('aria-controls', popupId);

        triggerBlock.addEventListener('click', openPopup);
        triggerBlock.addEventListener('keydown', (event) => {
            if (event.key === 'Enter' || event.key === ' ') {
                event.preventDefault();
                openPopup();
            }
        });
    });

    /********* Demande d'echantillon *********/
    /* L'envoi passe en fetch : la page de retour de Shopify est relue pour y trouver le statut
       du formulaire. Si ce statut est absent (challenge anti-bot, reponse inattendue), on retombe
       sur l'envoi natif, qui recharge la page avec ?contact_posted et l'ancre du formulaire :
       l'ancre le distingue de « Poser une question », lui aussi de type contact. */
    const sampleRequestForm = document.querySelector('[data-sample-request-form]');
    if (sampleRequestForm) {
        const sampleFormElement = sampleRequestForm.closest('form');
        const sampleSelected = sampleRequestForm.querySelector('[data-sample-selected]');
        const updateSampleSelected = () => {
            const checkedSample = sampleRequestForm.querySelector('[data-sample-label]:checked');
            sampleSelected.textContent = checkedSample ? checkedSample.dataset.sampleLabel : '';
        };
        updateSampleSelected();
        sampleRequestForm.querySelectorAll('[data-sample-label]').forEach((sampleInput) => {
            sampleInput.addEventListener('change', updateSampleSelected);
        });

        sampleFormElement.addEventListener('submit', async (event) => {
            event.preventDefault();
            const submitButton = sampleFormElement.querySelector('[data-sample-submit]');
            submitButton.classList.add('btn--loading');
            submitButton.setAttribute('aria-busy', 'true');

            try {
                const response = await fetch(sampleFormElement.action, {
                    method: 'POST',
                    body: new FormData(sampleFormElement),
                });
                const responseDocument = new DOMParser().parseFromString(await response.text(), 'text/html');
                const responseForm = responseDocument.getElementById(sampleFormElement.id);
                const responseStatus = responseForm?.querySelector('[data-sample-request-form]')?.dataset.sampleStatus;

                if (responseStatus === 'success') {
                    sampleFormElement.reset();
                    updateSampleSelected();
                    sampleRequestForm.querySelector('[data-sample-errors]').innerHTML = '';
                    document.getElementById(sampleRequestForm.dataset.modalId)?.hide();
                    showSampleToast(sampleRequestForm.querySelector('[data-sample-toast]'));
                } else if (responseStatus === 'error') {
                    sampleRequestForm.querySelector('[data-sample-errors]').innerHTML =
                        responseForm.querySelector('[data-sample-errors]').innerHTML;
                } else {
                    sampleFormElement.submit();
                }
            } catch (error) {
                sampleFormElement.submit();
            } finally {
                submitButton.classList.remove('btn--loading');
                submitButton.removeAttribute('aria-busy');
            }
        });

        const sampleStatus = sampleRequestForm.dataset.sampleStatus;
        if (sampleStatus && window.location.hash === '#' + sampleFormElement.id) {
            const cleanUrl = new URL(window.location.href);
            cleanUrl.searchParams.delete('contact_posted');
            cleanUrl.hash = '';
            history.replaceState(null, '', cleanUrl);

            if (sampleStatus === 'error') {
                customElements.whenDefined('basic-modal').then(() => {
                    document.getElementById(sampleRequestForm.dataset.modalId)?.show();
                });
            } else {
                showSampleToast(sampleRequestForm.querySelector('[data-sample-toast]'));
            }
        }
    }

    function showSampleToast(toastTemplate) {
        const toast = toastTemplate.content.firstElementChild.cloneNode(true);
        const secondsElement = toast.querySelector('[data-sample-toast-seconds]');
        let remainingSeconds = Number(secondsElement.textContent);
        toast.style.setProperty('--sample-toast-duration', remainingSeconds + 's');

        const closeToast = () => {
            clearInterval(countdown);
            toast.remove();
        };
        const countdown = setInterval(() => {
            remainingSeconds -= 1;
            if (remainingSeconds <= 0) {
                closeToast();
                return;
            }
            secondsElement.textContent = remainingSeconds;
        }, 1000);

        toast.querySelector('[data-sample-toast-close]').addEventListener('click', closeToast);
        document.body.append(toast);
    }
}

/********* Reinitialize product sliders on facet update *********/
FoxTheme.pubsub.subscribe(FoxTheme.pubsub.PUB_SUB_EVENTS.facetUpdate, () => {
    setTimeout(() => {
        const productSliders = document.querySelectorAll('card-product-image-slider');
        sliderCardProduct(productSliders);
    }, 100);
});

/********* Recherche desktop : saisie possible des l'ouverture du tiroir *********/
/* ModalComponent ne place le focus qu'a la fin de la transition de l'overlay (~0,9 s) :
   les frappes tapees avant sont perdues. On focus le champ des l'ouverture, puis on
   empeche trapFocus de selectionner tout le texte deja saisi a la fin de la transition. */
customElements.whenDefined('search-drawer').then(() => {
    const SearchDrawer = customElements.get('search-drawer');
    const { show, handleAfterShow } = SearchDrawer.prototype;

    SearchDrawer.prototype.show = function (...args) {
        const shown = show.apply(this, args);
        const input = this.focusElement;
        if (this.open && input && !FoxTheme.config.mqlTablet) {
            input.focus({ preventScroll: true });
            if (input.value) input.select();
        }
        return shown;
    };

    SearchDrawer.prototype.handleAfterShow = function () {
        const input = this.focusElement;
        const typedBeforeEnd = input && document.activeElement === input;
        const { selectionStart, selectionEnd } = input || {};
        handleAfterShow.call(this);
        if (typedBeforeEnd) input.setSelectionRange(selectionStart, selectionEnd);
    };
});
